module.exports = "img/flags/MT.32eba2a.png";